import { css } from '@emotion/css';
import { useAnalytics } from '@volumental/analytic';
import { Button, Headline, TextButton } from '@volumental/common';
import { type JSX } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Modal } from '../../../components/modal/modal';
import { uiConfig } from '../../../services/config';
import { usePersistedViewStore } from '../../../store';
import { CookieType } from '../../../types/types';

const common = css`
  font-family: ${uiConfig.styles.fontFamily};
  font-style: normal;
  color: ${uiConfig.styles.colors.black};
`;

const descriptionStyle = css`
  ${common}
  font-weight: ${uiConfig.styles.fontWeights.regular};
  font-size: ${uiConfig.styles.fontSizes.regular};
  line-height: 21px;
  margin-bottom: 24px;
`;

interface CookieModalProps {
  close: () => void;
  next: () => void;
  show: boolean;
}

export function CookieModal({
  close,
  next,
  show,
}: CookieModalProps): JSX.Element {
  const cookieLink = 'https://volumental.com/policy/cookie-policy';
  const dataProtectionLink = 'https://volumental.com/policy/privacy-policy';
  const { optOutUser } = useAnalytics();
  const { setCookieType } = usePersistedViewStore((store) => store);
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      close={close}
      fitContent
      disableScrollBar
      modalTitle={t('cookiesModal.title')}
    >
      <Headline style={{ fontSize: '21px', fontWeight: 'bold' }}>
        {t('cookiesModal.title')}
      </Headline>
      <div className={descriptionStyle}>
        <Trans
          i18nKey="cookiesModal.description"
          components={{
            link1: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a
                href={cookieLink}
                target="_blank"
                style={{ fontWeight: 'bold', color: 'black' }}
                rel="noreferrer"
              />
            ),
            link2: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a
                href={dataProtectionLink}
                target="_blank"
                style={{ fontWeight: 'bold', color: 'black' }}
                rel="noreferrer"
              />
            ),
          }}
        />
      </div>
      <div
        style={{
          paddingBottom: 30,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Button
          loading={false}
          type="submit"
          onClick={() => {
            setCookieType(CookieType.All);
            next();
          }}
        >
          {t('cookiesModal.acceptBT')}
        </Button>
        <TextButton
          onClick={() => {
            setCookieType(CookieType.Essential);
            optOutUser(true);
            next();
          }}
          style={{ marginTop: '25px' }}
        >
          {t('cookiesModal.limitBt')}
        </TextButton>
      </div>
    </Modal>
  );
}
